import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/production/workOrder'
//进行开工
export const Startppi = (params) => {
  return axios.post(`${rootApi}/Startppi`, params,)
}
//进行报工
export const StartppireportWork = (params) => {
  return axios.post(`${rootApi}/reportWork`, params)
}
//产品清单
export const getChildWorkOrderByMergeWorkOrderId = (params) => {
  return axios.get(`/api_v2/inspect/workOrderMerge/getChildWorkOrderByMergeWorkOrderId/${params}`,)
}
//工卡
export const getProcessFlowPrintPage = (params) => {
  return axios.get(`/api_v2/production/processFlowOrder/printProcessFlow`,{params},)
}